import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

export const Pause = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Status);

  return (
    <Stack>
      <Typography variant='body6'>{dictionary.steps.pause.info1}</Typography>
      <Typography variant='body6'>{dictionary.steps.pause.info3}</Typography>
    </Stack>
  );
};
